import React from "react";
import { ClerkProvider } from "@clerk/clerk-react";

const localization = {
  signUp: {
    start: {
      title: "Create your account",
      subtitle: "Start building your AI memory",
    },
    emailCode: {
      title: "Verify your email",
      subtitle: "Check your email for a verification code",
    },
  },
};

interface AuthProviderProps {
  children: React.ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  // Try to get the key from Vite environment variables first, then fallback
  const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

  if (!publishableKey) {
    console.error("Missing Clerk Publishable Key");
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <h2>Configuration Error</h2>
        {/* Print error message only in dev mode */}
        {import.meta.env.DEV && (
          <>
            <p>
              Missing Clerk Publishable Key. Please check your environment
              variables.
            </p>
            <p>Expected: VITE_CLERK_PUBLISHABLE_KEY</p>
          </>
        )}
      </div>
    );
  }

  return (
    <ClerkProvider publishableKey={publishableKey} localization={localization}>
      {children}
    </ClerkProvider>
  );
};

export default AuthProvider;
